import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ConfigPais = {

    async Get() {  return await methods.Get("ConfigPais/Get" ); },
    async Post(data) { return await methods.Post("ConfigPais/Post", data) },
    async Put(qs, data) { return await methods.Put("ConfigPais/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ConfigPais/Delete" + useParamsJson(qs)) }
};

export default ConfigPais;